/* eslint-disable */
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import * as intlTelInput from 'intl-tel-input';
import $ from 'jquery';
import React from 'react';
import '../../../node_modules/intl-tel-input/build/css/intlTelInput.css';
import '../../../node_modules/intl-tel-input/build/js/utils';
import CustomPhoneInputPropTypes from './CustomPhoneInput.component.props';

/**
 * CustomPhoneInputComponent
 * @export
 * @class CustomPhoneInputComponent
 * @extends {React.Component<CustomPhoneInputPropTypes>}
 */
class CustomPhoneInput extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<CustomPhoneInputComponentProps>}
   * @memberof CustomPhoneInputComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`CustomPhoneInputComponent`}
   * @memberof CustomPhoneInputComponent
   */
  static displayName = `CustomPhoneInputComponent`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof CustomPhoneInputComponent
   */
  static propTypes = CustomPhoneInputPropTypes;

  /**
   * The constructor
   * @static
   * @type {Object}
   * @memberof CustomPhoneInputComponent
   * @param {Object} props The props object
   */
  constructor(props) {
    super(props);
    const { value } = props;

    this.state = {
      errorMap: [`Invalid number`, `Invalid country code`, `Too short`, `Too long`, `Invalid number`],
      errorText: ``,
      value: value || ``,
    };
  }

  /**
   * Component did mount
   * @memberof CustomPhoneInputComponent
   * @returns {void} void
   */
  componentDidMount = () => {
    const { id, value, originalValue } = this.props;
    if (typeof originalValue !== 'undefined' && value !== originalValue) {
      this.setState({ isTouched: true });
    }
    const inputP = document.querySelector(`#${id}`);

    /* this is a workaround to get the google phone lib working in react, not the best option but works */
    $(document).ready(() => {
      const intlTel = intlTelInput(inputP, {
        initialCountry: `au`,
        onlyCountries: [`au`],
        separateDialCode: false,
        utilsScript: `../../../node_modules/intl-tel-input/build/js/utils`, // The node package is version locked, again workaround.
      });
      this.setState({ component: intlTel });
    });
  };

  /**
   * Handles the change event for custom phone number field
   * @param {string} phoneNumber The phoneNumber string
   * @memberof CustomPhoneInputComponent
   * @returns {void} void
   */
  handleChange = (phoneNumber) => (event) => {
    const { component, errorMap } = this.state;
    const { emptyValid, classTouched, classEditable, value: originalValue } = this.props;

    // Sets the state with the correct vaule
    this.setState({ value: event.target.value });

    if (classTouched && classEditable) {
      this.setState({ isTouched: true });
    } else {
      this.setState({ isTouched: false });
    }

    // Santizes the phone number
    const number = component.getNumber();

    // Passing back to the component
    const { onPhoneNumberChange, id } = this.props;

    // For the error checking
    let error = ``;

    if (event.target.value.trim().length === 0 && emptyValid) {
      error = false;
      this.setState({ errorText: false });
    }

    // Does te vaildation
    else if (event.target.value.trim()) {
      if (component.isValidNumber()) {
        error = false;
        this.setState({ errorText: false });
      } else {
        error = true;
        const errorCode = component.getValidationError();
        this.setState({ errorText: errorMap[errorCode] });
      }
    }
    // Pass the data to the outer component and report if its been modified
    const isOriginalNumber = originalValue === event.target.value;
    onPhoneNumberChange(id, event.target.value, error, isOriginalNumber);
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<CustomPhoneInputComponent />`
   * @memberof CustomPhoneInputComponent
   */
  render() {
    const { errorText, value, isTouched } = this.state;
    const { id, label, onFocus = () => {}, onBlur = () => {}, fullWidth, helperText, classTouched, classEditable, classHelperRoot } = this.props;
    let fieldClass = null;
    const { value: value1, originalValue } = this.props;

    if (classTouched && classEditable) {
      fieldClass = isTouched && (typeof originalValue !== 'undefined' ? originalValue : value1) !== value ? classEditable : classTouched;
    }

    return (
      <React.Fragment>
        <TextField
          error={!!errorText}
          helperText={errorText}
          id={id}
          InputProps={{
            className: fieldClass,
          }}
          fullWidth={!!fullWidth}
          onFocus={onFocus}
          onBlur={onBlur}
          InputLabelProps={{ shrink: true }}
          label={label}
          margin="normal"
          onChange={this.handleChange(`phoneNumber`)}
          type="tel"
          value={value}
        />
        {helperText && (
          <FormHelperText id="sms-helper-text" classes={{ root: classHelperRoot }}>
            {helperText}
          </FormHelperText>
        )}
      </React.Fragment>
    );
  }
}

export default CustomPhoneInput;
